<template>
  <v-app>
    <!-- Header -->
    <header class="header">
      <div class="header-container">
        <nav class="nav">
          <!-- Logo -->
          <div class="logo">
            <a href="https://intelite.com.br/" target="_blank" rel="noopener noreferrer">
              <img 
                src="../assets/logoInteliteAzul.png" 
                alt="Intelite Tecnologia" 
                class="logo-image"
              />
            </a>
          </div>

          <!-- Menu Desktop -->
          <div class="nav-desktop">
            <button
              v-for="item in menuItems"
              :key="item.id"
              @click="scrollToSection(item.id)"
              class="nav-button"
              :class="{ 'active': activeSection === item.id }"
            >
              <span 
                class="nav-underline"
                :class="{ 'active': activeSection === item.id }"
              ></span>
              {{ item.label }}
            </button>
          </div>

          <!-- Botão Login Desktop -->
          <div class="login-desktop">
            <button
              @click="goToLogin"
              class="login-button"
            >
              <svg class="login-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
              </svg>
              LOGIN
            </button>
          </div>

          <!-- Menu Mobile Button -->
          <button
            @click="toggleMenu"
            class="menu-toggle"
          >
            <svg
              class="menu-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                v-if="!isMenuOpen"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
              <path
                v-else
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </nav>
      </div>

      <!-- Overlay escuro -->
      <div v-if="isMenuOpen" class="overlay" @click="toggleMenu"></div>

      <!-- Menu Mobile -->
      <div
        class="nav-mobile"
        :class="{ 'open': isMenuOpen }"
      >
        <div class="nav-mobile-content">
          <button
            v-for="item in menuItems"
            :key="item.id"
            @click="scrollToSection(item.id)"
            class="nav-button-mobile"
            :class="{ 'active': activeSection === item.id }"
          >
            {{ item.label }}
          </button>
          
          <!-- Botão Login Mobile -->
          <button
            @click="goToLogin"
            class="login-button"
          >
            <svg class="login-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            LOGIN
          </button>
        </div>
      </div>
    </header>

    <v-main>
      <section id="home" class="hero-section">
        <v-img src="../assets/logointerna.png" class="hero-banner" />
        <div class="hero-text-overlay">
          <div class="hero-text-content">
            <div class="hero-text-logo-container">
              <h1 class="hero-title animate-fadeInLeft">
                Com o <span class="aicheckin-highlight">AiCheckin</span>, o acesso<br>
                é rápido, fácil e 100% digital.
              </h1>
              <div class="hero-logo animate-fadeInRight">
                <v-img src="../assets/logoaicheckin.png" max-width="200" contain class="aicheckin-logo" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="produtos" class="image-section py-8">
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12" sm="11" md="11" lg="10" xl="9" class="text-center">
              <div class="retangulo-molde">
                <div class="imagem-conteudo"></div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="sobre" class="text-content-section py-16">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" sm="11" md="11" lg="10" xl="9">
               <div class="sobre-content-wrapper">
                <h2 class="section-title mb-6">Sobre o AiCheckin</h2>
                <div class="about-text-content">
                  <p class="section-description mb-4">
                    Eventos sem filas e com venda de ingressos online descomplicadas? Aicheckin é a solução!
                  </p>
                  <p class="section-description">
                    Com o objetivo de tornar o evento uma experiência incrível, o AICHECKIN simplifica o acesso a eventos ao permitir a venda de ingressos online, realizar o check-in dos participantes e gerenciar com precisão o número de inscritos. Ele oferece flexibilidade nas opções de pagamento, permite a comunicação com os participantes via WhatsApp, além de possibilitar o envio de certificados, aumentando a eficiência geral. Além disso, proporciona um controle abrangente do evento, incluindo o acesso à lista VIP, e fornece informações essenciais para um planejamento e execução mais eficaz.
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="vantagens" class="vantagens-section py-16">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" sm="11" md="11" lg="10" xl="9">
              <div class="vantagens-content-wrapper">
                <v-img src="../assets/vantagens.png" max-width="900" contain class="vantagens-image" />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section class="vantagens-list-section py-12">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" sm="11" md="11" lg="10" xl="9">
              <div class="vantagens-content-wrapper">
                <ul class="vantagens-list">
                  <li class="vantagem-item" v-for="(vantagem, index) in vantagens" :key="index">
                    <img src="../assets/iconecheckbox.png" class="vantagem-icon" />
                    <span class="vantagem-text">{{ vantagem }}</span>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="clientes" class="clientes-section py-12">
        <v-container>
          <div class="clientes-content-wrapper">
            <v-img src="../assets/clientes.png" max-width="900" contain class="clientes-image" />
          </div>
        </v-container>
      </section>

      <section class="logos-clientes-section py-8">
        <v-container>
          <div class="clientes-content-wrapper">
            <!-- Primeira linha - 3 logos -->
            <v-row justify="center" align="center" class="logos-grid mb-6" no-gutters>
              <v-col cols="4" sm="4" md="4" class="text-center pa-0">
                <v-img src="../assets/perfumadaslogo.png" max-width="200" max-height="100" contain
                  class="mx-auto logo-cliente" />
              </v-col>
              <v-col cols="4" sm="4" md="4" class="text-center pa-0">
                <v-img src="../assets/domuslogo.png" max-width="200" max-height="100" contain
                  class="mx-auto logo-cliente" />
              </v-col>
              <v-col cols="4" sm="4" md="4" class="text-center pa-0">
                <v-img src="../assets/klaeventoslogo.png" max-width="200" max-height="100" contain
                  class="mx-auto logo-cliente" />
              </v-col>
            </v-row>
            
            <!-- Segunda linha - 3 logos -->
            <v-row justify="center" align="center" class="logos-grid" no-gutters>
              <v-col cols="4" sm="4" md="4" class="text-center pa-0">
                <v-img src="../assets/barberprologo.png" max-width="200" max-height="100" contain
                  class="mx-auto logo-cliente" />
              </v-col>
              <v-col cols="4" sm="4" md="4" class="text-center pa-0">
                <v-img src="../assets/vistalegrelogo.png" max-width="200" max-height="100" contain
                  class="mx-auto logo-cliente" />
              </v-col>
              <v-col cols="4" sm="4" md="4" class="text-center pa-0">
                <v-img src="../assets/festveraologo.png" max-width="200" max-height="100" contain
                  class="mx-auto logo-cliente" />
              </v-col>
            </v-row>
          </div>
        </v-container>
      </section>

      <section id="contato" class="contato-section py-16">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" class="text-center">
              <v-btn class="cta-whatsapp-btn" rounded large href="https://wa.me/558335125222" target="_blank">
                <v-icon left large color="white">mdi-whatsapp</v-icon>
                FALE CONOSCO
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section class="footer-shape-section">
        <v-container>
          <v-row justify="center" class="mb-6">
            <v-col cols="12" class="text-center">
              <a href="https://intelite.com.br/" target="_blank" class="footer-logo-link">
                <v-img src="../assets/logo-branco-orizontal.png" max-width="200" contain
                  class="mx-auto footer-logo" />
              </a>
            </v-col>
          </v-row>

          <v-row justify="center" class="mb-3">
            <v-col cols="12" md="10" lg="8">
              <v-row justify="space-between" align="start">
                <v-col cols="12" md="4" class="text-left mb-6 mb-md-0">
                  <h3 class="footer-column-title">ENDEREÇO</h3>
                  <div class="footer-info-item">
                    <v-icon color="white" class="footer-icon">mdi-map-marker</v-icon>
                    <div class="footer-info-text">
                      <div>R. Carteiro Olivio Pontes, 575 - Água Fria</div>
                      <div>João Pessoa - PB, 58053-020</div>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="text-left mb-6 mb-md-0">
                  <h3 class="footer-column-title">CONTATO</h3>
                  <div class="footer-info-item">
                    <v-icon color="white" class="footer-icon">mdi-whatsapp</v-icon>
                    <div class="footer-info-text">(83) 3512-5222</div>
                  </div>
                  <div class="footer-info-item">
                    <v-icon color="white" class="footer-icon">mdi-email</v-icon>
                    <div class="footer-info-text">comercial@intelite.com.br</div>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="text-left">
                  <h3 class="footer-column-title">REDES SOCIAIS</h3>
                  <div class="footer-social-icons">
                    <a href="https://www.instagram.com/intelite_tecnologia/" target="_blank" class="social-icon">
                      <v-icon color="white">mdi-instagram</v-icon>
                    </a>
                    <a href="https://www.linkedin.com/company/intelite-tecnologia/" target="_blank" class="social-icon">
                      <v-icon color="white">mdi-linkedin</v-icon>
                    </a>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row justify="center" class="mb-4">
            <v-col cols="12" class="text-center">
              <div class="footer-separator"></div>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="12" class="text-center">
              <div class="footer-copyright">
                <p>© 2025 Intelite Tecnologia. Todos os direitos reservados.</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <a href="https://wa.me/558335125222" target="_blank" class="whatsapp-floating-button">
        <v-icon color="white" class="whatsapp-floating-icon">mdi-whatsapp</v-icon>
      </a>

    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "LadingPage",
  data() {
    return {
      isMenuOpen: false,
      activeSection: 'home',
      isScrolling: false,
      menuItems: [
        { id: 'home', label: 'HOME' },
        { id: 'sobre', label: 'SOBRE' },
        { id: 'vantagens', label: 'VANTAGENS' },
        { id: 'clientes', label: 'CLIENTES' },
        { id: 'contato', label: 'CONTATO' }
      ],
      vantagens: [
        "Contratação assistida",
        "Gestão de vendas em tempo real",
        "Comunicação com o público pelo WhatsApp",
        "Link de venda sem formulários complexos",
        "Check-in com QR code, reconhecimento facial e CPF do participante",
        "Envio de certificados",
        "Link de divulgador/associados"
      ]
    };
  },
  mounted() {
    window.addEventListener('scroll', this.updateActiveSection)
    this.updateActiveSection()
    this.setupScrollAnimations();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateActiveSection)
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },

    goToLogin() {
      this.$router.push('/login')
    },
    
    scrollToSection(sectionId) {
      // Define imediatamente a seção ativa para evitar piscadas
      this.activeSection = sectionId
      this.isMenuOpen = false
      this.isScrolling = true // Desabilita updateActiveSection durante o scroll
      
      if (sectionId === 'contato') {
        // Para contato, vai para o footer
        const footer = document.querySelector('.footer-shape-section')
        if (footer) {
          const headerHeight = 86
          const targetPosition = footer.offsetTop - headerHeight
          
          // Scroll suave com animação personalizada
          this.smoothScrollTo(targetPosition)
        }
      } else {
        // Para outras seções, comportamento normal
        const element = document.getElementById(sectionId)
        if (element) {
          const headerHeight = 86
          const targetPosition = element.offsetTop - headerHeight
          
          // Scroll suave com animação personalizada
          this.smoothScrollTo(targetPosition)
        }
      }
    },

    smoothScrollTo(targetPosition) {
      const startPosition = window.pageYOffset
      const distance = targetPosition - startPosition
      const duration = 800 // 800ms
      let start = null

      const animation = (currentTime) => {
        if (start === null) start = currentTime
        const timeElapsed = currentTime - start
        const run = this.easeInOutQuad(timeElapsed, startPosition, distance, duration)
        window.scrollTo(0, run)
        if (timeElapsed < duration) {
          requestAnimationFrame(animation)
        } else {
          // Reabilita updateActiveSection quando terminar o scroll
          this.isScrolling = false
        }
      }

      requestAnimationFrame(animation)
    },

    easeInOutQuad(t, b, c, d) {
      t /= d / 2
      if (t < 1) return c / 2 * t * t + b
      t--
      return -c / 2 * (t * (t - 2) - 1) + b
    },

    updateActiveSection() {
      // Não atualiza durante o scroll programático
      if (this.isScrolling) return
      
      const sections = ['home', 'sobre', 'vantagens', 'clientes']
      const headerHeight = 100

      for (const sectionId of sections) {
        const element = document.getElementById(sectionId)
        if (element) {
          const rect = element.getBoundingClientRect()
          
          if (rect.top <= headerHeight && rect.bottom > headerHeight) {
            // Só atualiza se for diferente da seção atual
            if (this.activeSection !== sectionId) {
              this.activeSection = sectionId
            }
            return
          }
        }
      }
      
      // Se chegou até aqui, verifica se está no footer
      const footer = document.querySelector('.footer-shape-section')
      if (footer) {
        const rect = footer.getBoundingClientRect()
        // Só marca como contato se estiver realmente no footer
        if (rect.top <= headerHeight && rect.bottom > headerHeight) {
          if (this.activeSection !== 'contato') {
            this.activeSection = 'contato'
          }
        }
      }
    },
    setupScrollAnimations() {
      // Elementos que devem ser animados
      const animatedElements = [
        { selector: '.hero-banner', animation: 'fadeInUp' },
        { selector: '.retangulo-molde', animation: 'fadeInUp' },
        { selector: '.section-title', animation: 'fadeInRight' },
        { selector: '.section-description', animation: 'fadeInRight' },
        { selector: '.vantagens-image', animation: 'fadeInLeft' },
        { selector: '.vantagem-item', animation: 'fadeInUp' },
        { selector: '.clientes-image', animation: 'fadeInLeft' },
        { selector: '.logo-cliente', animation: 'fadeInUp' },
        { selector: '.cta-whatsapp-btn', animation: 'bounceInUp' }
      ];

      // Configuração do Intersection Observer
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target;
            
            // Aplicar animação baseada no tipo de elemento
            if (element.classList.contains('vantagem-item')) {
              // Para itens de vantagem, aplicar delay baseado na posição
              const items = document.querySelectorAll('.vantagem-item');
              const index = Array.from(items).indexOf(element);
              element.style.animationDelay = `${index * 0.2}s`;
              element.classList.add('animate-fadeInUp');
            } else if (element.classList.contains('logo-cliente')) {
              // Para logos de clientes, aplicar delay baseado na posição
              const logos = document.querySelectorAll('.logo-cliente');
              const index = Array.from(logos).indexOf(element);
              element.style.animationDelay = `${index * 0.2}s`;
              element.classList.add('animate-fadeInUp');
            } else {
              // Para outros elementos, aplicar animação diretamente
              const animationClass = element.dataset.animation || 'fadeInUp';
              element.classList.add(`animate-${animationClass}`);
            }
            
            // Parar de observar o elemento após animação
            observer.unobserve(element);
          }
        });
      }, observerOptions);

      // Observar todos os elementos
      animatedElements.forEach(({ selector, animation }) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          element.dataset.animation = animation;
          element.classList.add('animate-ready');
          observer.observe(element);
        });
      });
    }
  }
};
</script>

<style scoped>
.v-main {
  padding-top: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 0 !important;
}

.v-main__wrap,
.v-content,
.v-content__wrap {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

@font-face {
  font-family: "AlibabaSans-B";
  src: url("/fonts/AlibabaSans-Bold.ttf");
  font-weight: bold;
}


@font-face {
  font-family: "FONTSPRINGDEMO";
  src: url("/fonts/FONTSPRINGDEMO-Medium.otf");
  font-weight: normal;
}

@font-face {
  font-family: "MyriadPro-Reg";
  src: url("/fonts/MyriadPro-Regular.otf");
}

@font-face {
  font-family: "Montserrat";
  src: url("/fonts/Montserrat-Regular.ttf");
  font-weight: normal;
}

.hero-section {
  position: relative;
  overflow: hidden;
  padding: 0;
  margin-top: 0 !important;
  margin-left: -24px;
  margin-right: -24px;
}


.hero-banner {
  width: 100%;
  height: 500px;
  display: block;
  min-height: 350px;
  object-fit: contain !important;
  object-position: center center !important;
}

.hero-text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 2;
  padding: 20px;
  padding-bottom: 60px;
}

.hero-text-content {
  text-align: right;
  max-width: 1200px;
  width: 100%;
}

.hero-text-logo-container {
  display: flex;
  align-items: center;
  gap: 30px;
  justify-content: flex-start;
}

.hero-logo {
  flex-shrink: 0;
}

.aicheckin-logo {
  max-width: 300px;
  height: auto;
}

.hero-title {
  font-family: "Arial Black", "Helvetica Neue", Arial, sans-serif;
  font-size: 3rem;
  font-weight: 900;
  color: #ffffff;
  line-height: 1.2;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.aicheckin-highlight {
  color: #debfff;
  font-family: "Arial Black", "Helvetica Neue", Arial, sans-serif;
  font-weight: 900;
}

.hero-section .v-container {
  position: relative;
  z-index: 2;
}


@media (max-width: 960px) {
  .hero-title {
    font-size: 2.2rem;
    padding: 0 1rem;
  }
  
  .hero-text-overlay {
    padding: 15px;
    padding-bottom: 50px;
  }
  
  .hero-text-logo-container {
    gap: 20px;
  }
  
  .aicheckin-logo {
    max-width: 220px;
  }

  .header-logo {
    height: 45px !important;
    max-width: 200px !important;
  }

  .header-custom {
    height: 70px !important;
    overflow: visible !important;
  }
  
  .header-content {
    padding: 0 20px;
  }


  .mobile-menu-container {
    position: relative;
  }

  .mobile-dropdown-menu {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background: white;
    border: none;
    border-radius: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1001;
    width: 100vw;
    padding: 20px 0;
    margin: 0;
  }

  .header-link {
    font-size: 13px !important;
    padding: 6px 10px !important;
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 2rem;
    line-height: 1.3;
  }
  
  .hero-text-overlay {
    padding: 10px 2px;
    padding-bottom: 40px;
  }
  
  .hero-text-logo-container {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  
  .aicheckin-logo {
    max-width: 180px;
  }
  
  .hero-text-content {
    max-width: 100%;
  }
  
  .hero-title {
    text-align: center;
  }

  .header-logo {
    height: 40px !important;
  }
  
  .header-content {
    padding: 0 15px;
  }


  .mobile-dropdown-menu {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    width: 100vw;
    padding: 20px 0;
  }

  .header-link {
    font-size: 11px !important;
    padding: 4px 6px !important;
  }

  .aicheckin-seal img {
    max-width: 200px !important;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.6rem;
    line-height: 1.4;
  }
  
  .hero-text-overlay {
    padding: 8px 1px;
    padding-bottom: 30px;
  }
  
  .hero-text-logo-container {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
  
  .aicheckin-logo {
    max-width: 150px;
  }
  
  .hero-title {
    text-align: center;
  }
}

@media (max-width: 375px) {
  .hero-banner {
    height: 0;
    padding-top: 25%;
    background-image: url('../assets/logointerna.png');
    background-size: 120% auto;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    position: relative;
    z-index: 2;
  }
}

@media (max-width: 320px) {
  .hero-banner {
    height: 0;
    padding-top: 20%;
    background-image: url('../assets/logointerna.png');
    background-size: 120% auto;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    position: relative;
    z-index: 2;
  }
}

@media (max-width: 280px) {
  .hero-banner {
    height: 0;
    padding-top: 15%;
    background-image: url('../assets/logointerna.png');
    background-size: 120% auto;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    position: relative;
    z-index: 2;
  }
}




/* Header */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 50;
  height: 86px; 
  border-top: 3px solid #0f0f41;
  transition: all 0.3s ease;
}

@media (max-width: 768px) {
  .header {
    height: 80px;
  }
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 16px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.logo {
  width: 160px;
  overflow: visible; /* evita cortes da imagem ao ajustar a posição */
}

.logo a {
  text-decoration: none;
  display: block;
}

.logo-image {
  height: auto;
  width: 100%;
  margin-left: 0; /* evita sumir com zoom e mantém dentro do container */
  transition: opacity 0.3s ease;
}

/* Aproxima somente a imagem no desktop, mantendo layout intacto */
@media (min-width: 960px) {
  .logo-image {
    margin-left: 0;
    transform: translateX(-30px); /* deslocamento moderado no 100% */
  }
}

@media (min-width: 1440px) {
  .logo-image {
    transform: translateX(-60px); /* telas grandes */
  }
}

@media (min-width: 1920px) {
  .logo-image {
    transform: translateX(-90px); /* ultrawide */
  }
}

@media (max-width: 768px) {
  .logo {
    width: 140px;
  }
  
  .logo-image {
    margin-left: 0px;
  }
}

.logo a:hover .logo-image {
  opacity: 0.8;
}

.nav-desktop {
  display: flex;
  flex: 1;
  justify-content: center;
  gap: 48px;
}

.login-desktop {
  display: flex;
  align-items: center;
  margin-left: auto;
  height: 100%;
}

.nav-button {
  color: #374151;
  background: none;
  border: none;
  font-weight: 700;
  position: relative;
  padding: 8px 0;
  cursor: pointer;
  transition: color 0.3s ease;
  text-transform: uppercase;
  font-size: 16px;
}

.nav-button:hover {
  color: #111827;
}

.nav-button.active {
  color: #2B3674;
  font-weight: 700;
}

.nav-underline {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #2B3674;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.nav-underline.active {
  transform: scaleX(1);
}

.login-button {
  background: #2B3674;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
}

.login-button:hover {
  background: #1e2a5e;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(43, 54, 116, 0.3);
}

.login-icon {
  width: 14px;
  height: 14px;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: #374151;
  cursor: pointer;
  position: absolute;
  right: 60px;
  top: 50%;
  transform: translateY(-50%);
}

.menu-toggle:hover {
  color: #111827;
}

.menu-icon {
  width: 24px;
  height: 24px;
}

@media (max-width: 768px) {
  .menu-icon {
    width: 28px;
    height: 28px;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 30;
}

.nav-mobile {
  position: fixed;
  top: 86px;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 40;
  transform: translateY(-100%);
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.nav-mobile.open {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.nav-mobile-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 40px 0;
}

.nav-button-mobile {
  color: #374151;
  background: none;
  border: none;
  font-weight: 700;
  font-size: 20px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.nav-button-mobile:hover {
  color: #111827;
}

.nav-button-mobile.active {
  color: #2B3674;
  font-weight: 700;
}

/* Estilo para o botão de login no mobile (usando a mesma classe) */
.nav-mobile .login-button {
  margin-top: 16px;
}

/* Responsive */
@media (max-width: 768px) {
  .nav-desktop {
    display: none;
  }
  
  .login-desktop {
    display: none;
  }
  
  .menu-toggle {
    display: block;
    right: 15px;
  }
  
  .nav-mobile {
    top: 80px;
  }
}







/* Main Content */
.main {
  margin-top: 86px;
}

@media (max-width: 768px) {
  .main {
    margin-top: 80px;
  }
}






.image-section {
  background-color: white;
  padding-top: 40px !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  margin-bottom: -2px !important;
}

.retangulo-molde {
  position: relative;
  max-width: 1300px;
  margin: 0 auto;
  height: 0;
  padding-top: 52%;
  background-image: url('../assets/retangulo9.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #ffffff;
}

.imagem-conteudo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../assets/background9.png');
  background-size: 120% auto;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #ffffff;
}


.section-title {
  font-family: 'AlibabaSans', sans-serif;
  font-size: 2rem;
  color: #602882;
  margin-bottom: 30px;
  font-weight: 900;
  text-align: left;
  width: 100%;
}

.section-description {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.1rem;
  color: #333366;
  line-height: 1.6;
  text-align: justify;
  font-weight: 400;
  margin-bottom: 15px;
  text-indent: 0;
}

.text-content-section {
  background-color: white;
  padding-top: 40px !important;
  padding-bottom: 60px !important;
  text-align: left;
}

.text-content-section .v-container {
  text-align: left;
  max-width: 100%;
  padding-left: 16px;
  padding-right: 16px;
}

.text-content-section .v-row {
  justify-content: flex-start !important;
}

.text-content-section .v-col {
  text-align: left;
}

#sobre {
  margin-top: -12px;
}


.sobre-content-wrapper {
  max-width: 100%;
  margin: 0;
  width: 100%;
  text-align: left;
  padding: 0 16px;
}


.vantagens-section {
  background-color: white;
  text-align: center;
  padding: 20px 0 !important;
  margin-top: 0 !important;
}

.vantagens-section .v-container {
  text-align: center;
}

.vantagens-section .v-row {
  justify-content: center !important;
}

.vantagens-section .v-col {
  text-align: center;
}


.vantagens-content-wrapper {
  max-width: 1200px;
  margin: 0;
  width: 100%;
  text-align: center;
}

.vantagens-image {
  display: block;
  margin: 0 auto;
}


.clientes-section {
  background-color: white;
  text-align: center;
  padding: 12px 0;
}

.clientes-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  justify-content: center;
}

.clientes-content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.clientes-image {
  display: block;
  margin: 0 auto;
}

.logos-clientes-section {
  background-color: white;
  text-align: center;
  padding: 8px 0 !important;
  margin-top: -8px !important;
}

.logos-grid {
  gap: 0;
  margin: 0;
  padding: 0;
}

.logos-grid .v-row {
  margin: 0 !important;
  padding: 0 !important;
}

.logos-grid .v-col {
  padding-left: 1px !important;
  padding-right: 1px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  margin-left: -20px !important;
  margin-right: -20px !important;
}

.logo-cliente {
  transition: transform 0.3s ease;
  filter: grayscale(0%);
  opacity: 1;
  max-width: 200px !important;
  max-height: 100px !important;
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
}

.logo-cliente:hover {
  transform: scale(1.05);
}




.contato-section {
  background-color: white;
  margin-top: -6px !important;
}

.cta-whatsapp-btn {
  background-color: #1b2243 !important;
  color: #ffffff !important;
  border-radius: 30px !important;
  padding: 16px 32px !important;
  min-height: 60px;
  width: auto;
  max-width: 320px;
  font-family: "Montserrat", sans-serif !important;
  font-weight: 600 !important;
  letter-spacing: 0.8px !important;
  text-transform: uppercase !important;
  font-size: 16px !important;
  box-shadow: 0 4px 12px rgba(27, 34, 67, 0.4);
  border: 2px solid #1b2243;
  transition: all 0.3s ease;
  position: relative;
}

.cta-whatsapp-btn .v-icon {
  margin-right: 15px !important;
}

@media (max-width: 600px) {
  .cta-whatsapp-btn {
    padding: 14px 28px !important;
    min-height: 55px;
    font-size: 15px !important;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .cta-whatsapp-btn {
    padding: 12px 24px !important;
    min-height: 50px;
    font-size: 14px !important;
    max-width: 280px;
  }
}

.cta-whatsapp-btn:hover {
  background-color: #2a3a5c !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(27, 34, 67, 0.5);
  border-color: #2a3a5c;
}

.cta-whatsapp-btn::before {
  content: '';
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 1px;
  background-color: #e5e7eb;
  z-index: 1;
}

.footer-shape-section {
  background-color: #1b2243;
  background-image: url('../assets/shape.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  color: #ffffff;
  padding: 40px 0;
}

.footer-column-title {
  font-size: 16px;
  font-weight: bold;
  color: white;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: left;
}

.footer-info-item {
  display: flex;
  align-items: center;
  margin-top: 0;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 8px;
  text-align: left;
}

.footer-icon {
  font-size: 22px !important;
  flex-shrink: 0;
  margin-top: 2px;
  align-self: flex-start;
}

.footer-info-text {
  font-size: 16px;
  line-height: 1.5;
  color: white;
  text-align: left;
}

.footer-social-icons {
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  align-items: flex-start;
  margin-top: 0;
}

.social-icon {
  display: flex;
  align-items: center;
  margin-top: 0;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: transparent;
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon:hover {
  transform: scale(1.05);
  text-decoration: none;
}

.footer-separator {
  width: 100%;
  max-width: 1200px;
  height: 1px;
  background: #374151;
  margin: 30px auto;
  display: block;
}

.footer-copyright {
  text-align: center;
  padding-top: 20px;
}

.footer-copyright p {
  font-size: 14px;
  color: #ffffff;
  margin: 0;
}



.footer-logo-link {
  text-decoration: none;
  display: inline-block;
  transition: transform 0.3s ease;
}

.footer-logo-link:hover {
  text-decoration: none;
  transform: scale(1.05);
}

.footer-nav {
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-link {
  font-family: "Montserrat", sans-serif !important;
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-decoration: none;
  transition: color 0.3s ease;
  white-space: nowrap;
  margin: 0 8px;
}

.footer-link:hover {
  color: #84d4fd;
  text-decoration: none;
}

.footer-contact {
  font-family: "Montserrat", sans-serif !important;
  color: #ffffff;
  font-weight: 600;
  line-height: 1.4;
  font-size: 13px;
}

.contact-row {
  display: flex;
  align-items: flex-start;
  margin-top: 0;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.contact-row span {
  margin-left: 8px;
  flex: 1;
  min-width: 0;
}

.contact-address {
  line-height: 1.4;
}







@media (max-width: 600px) {
  .hero-section {
    padding: 0;
    margin: 0;
  }

  .hero-section+.image-section {
    margin-top: 20px !important;
  }

  .image-section {
    padding: 20px 0 !important;
    margin-top: 20px !important;
    position: relative;
    z-index: 1;
  }

  .hero-banner {
    height: 0;
    padding-top: 35%;
    background-image: url('../assets/logointerna.png');
    background-size: 120% auto;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    position: relative;
    z-index: 2;
  }

  .image-section .v-container {
    padding: 0 !important;
    margin: 0 !important;
  }

  .image-section .v-container,
  .vantagens-section .v-container,
  .vantagens-list-section .v-container,
  .clientes-section .v-container,
  .logos-clientes-section .v-container {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .text-content-section .v-container {
    padding-top: 20px !important;
    padding-bottom: 40px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  #sobre .mb-6 {
    margin-bottom: 12px !important;
  }

  .retangulo-molde {
    max-width: 100%;
    padding-top: 45%;
    margin: 0;
    width: 100%;
    position: relative;
    z-index: 1;
  }

  .sobre-content-wrapper {
    padding: 20px 16px;
  }

  .section-title {
    font-size: 1.8rem !important;
    margin-bottom: 15px;
  }

  .section-description {
    font-size: 1rem !important;
    line-height: 1.5;
  }
}

@media (max-width: 600px) {
  .imagem-conteudo {
    background-size: 120% auto;
    /* Cresce horizontalmente também no mobile */
    background-position: center center;
    /* Centraliza a imagem no mobile */
  }

  .section-image {
    max-width: 290px;
  }

  .logo-cliente {
    max-width: 100px !important;
    max-height: 50px !important;
    width: 100% !important;
    height: auto !important;
  }

  .sobre-title {
    font-size: 16px !important;
    margin-top: 0 !important;
    margin-bottom: 6px !important;
  }

  .sobre-text {
    font-size: 13px !important;
    margin-top: 2px !important;
    margin-bottom: 6px !important;
  }
}

@media (max-width: 480px) {
  .hero-banner {
    height: 0;
    padding-top: 30%;
    background-image: url('../assets/logointerna.png');
    background-size: 120% auto;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    position: relative;
    z-index: 2;
  }

  .retangulo-molde {
    padding-top: 40%;
    margin: 0;
    width: 100%;
    position: relative;
    z-index: 1;
  }

  .sobre-content-wrapper {
    padding: 15px 12px;
  }

  .text-content-section .v-container {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  .image-section {
    margin-top: 15px !important;
    padding: 15px 0 !important;
    position: relative;
    z-index: 1;
  }

  .logo-cliente {
    max-width: 80px !important;
    max-height: 40px !important;
    width: 100% !important;
    height: auto !important;
  }

  .footer-logo {
    max-width: 160px !important;
  }

  .footer-column {
    align-items: center !important;
    text-align: center !important;
  }

  .footer-column-title {
    text-align: center !important;
  }

  .footer-info-item {
    justify-content: center !important;
    text-align: center !important;
  }

  .footer-info-text {
    text-align: center !important;
  }

  .footer-social-icons {
    justify-content: center !important;
  }

  .footer-nav {
    gap: 10px;
  }

  .footer-link {
    font-size: 14px;
    margin: 2px 0;
  }

  .footer-contact {
    font-size: 12px;
  }

  .contact-address {
    font-size: 12px;
  }
}

@media (max-width: 600px) {
  .footer-nav {
    gap: 15px;
    align-items: flex-start;
    margin-top: 0;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 0;
  }

  .footer-link {
    margin: 4px 0;
  }

  .footer-logo {
    max-width: 180px !important;
  }

  .footer-column {
    align-items: center !important;
    text-align: center !important;
  }

  .footer-column-title {
    text-align: center !important;
  }

  .footer-info-item {
    justify-content: center !important;
    text-align: center !important;
  }

  .footer-info-text {
    text-align: center !important;
  }

  .footer-social-icons {
    justify-content: center !important;
  }

  .contact-row {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 0;
    text-align: center;
  }

  .contact-row span {
    margin-left: 0;
    margin-top: 4px;
  }

  .contact-address {
    font-size: 13px;
  }

  .sobre-title {
    font-size: 20px !important;
  }

  .sobre-text {
    font-size: 15px !important;
    line-height: 1.6 !important;
  }

  .vantagem-text {
    font-size: 16px !important;
  }
}



.vantagens-list-section {
  background-color: white;
  padding: 20px 0;
  margin-top: 0;
}

.vantagens-list-section .v-container {
  text-align: center;
}

.vantagens-list-section .v-row {
  justify-content: flex-start !important;
}

.vantagens-list-section .v-col {
  text-align: center;
}

.vantagens-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.vantagem-item {
  display: flex;
  align-items: flex-start;
  margin-top: 0;
  padding: 8px 0;
  margin: 0 0 8px 0;
  min-height: auto;
  width: 100%;
}

.vantagem-icon {
  margin-right: 10px;
  margin-top: 2px;
  align-self: flex-start;
  flex-shrink: 0;
  display: block;
}

.vantagem-text {
  font-family: "Montserrat", sans-serif !important;
  font-size: 26px !important;
  color: #000000 !important;
  line-height: 1.3;
  margin: 0;
  padding: 0;
  display: block;
  white-space: normal;
  word-break: break-word;
  flex: 1;
  text-align: left;
}

@media (max-width: 960px) {
  .vantagem-text {
    font-size: 20px !important;
  }

  .vantagem-icon {
    margin-right: 8px;
  }
}

@media (max-width: 600px) {
  .vantagem-item {
    padding: 6px 0;
    margin: 0 0 6px 0;
  }

  .vantagem-text {
    font-size: 16px !important;
    line-height: 1.4;
  }

  .vantagem-icon {
    margin-right: 8px;
    margin-top: 1px;
  }
}

@media (max-width: 480px) {
  .vantagem-item {
    padding: 4px 0;
    margin: 0 0 4px 0;
  }

  .vantagem-text {
    font-size: 14px !important;
    line-height: 1.5;
  }

  .vantagem-icon {
    margin-right: 6px;
    margin-top: 0;
  }
}

@media (max-width: 375px) {
  .vantagem-item {
    padding: 3px 0;
    margin: 0 0 3px 0;
  }

  .vantagem-text {
    font-size: 13px !important;
    line-height: 1.6;
  }

  .vantagem-icon {
    margin-right: 5px;
    margin-top: 0;
  }
}

.clientes-section {
  position: relative;
  background-color: white;
  padding: 10px 0;
  display: flex;
  align-items: center;
  margin-top: 0;
  justify-content: center;
}


.whatsapp-floating-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  margin-top: 0;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  z-index: 9999;
  transition: all 0.3s ease;
  text-decoration: none;
}

.whatsapp-floating-button:hover {
  background: #20BA5A;
  transform: scale(1.1);
  box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);
  text-decoration: none;
}

.whatsapp-floating-icon {
  font-size: 30px !important;
  color: white !important;
}

/* Animations */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounceInUp {
  0% {
    opacity: 0;
    transform: translateY(50px) scale(0.8);
  }
  50% {
    opacity: 0.8;
    transform: translateY(-10px) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Animation Classes */
.animate-ready {
  opacity: 0;
}

.animate-fadeInUp {
  animation: fadeInUp 0.8s ease-out forwards;
}

.animate-fadeInLeft {
  animation: fadeInLeft 0.8s ease-out forwards;
}

.animate-fadeInRight {
  animation: fadeInRight 0.8s ease-out forwards;
}

.animate-bounceInUp {
  animation: bounceInUp 1s ease-out forwards;
}

.animate-fadeInLeft {
  animation: fadeInLeft 1s ease-out forwards;
}

.animate-fadeInRight {
  animation: fadeInRight 1s ease-out forwards;
}


.social-icon .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

</style>